import { useForm } from "react-hook-form";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  AESEncryption,
  ApiResDecrypt,
} from "../../CommonMethhods/CommonMethods";
import axios from "axios";
import { Freeze_Unfreeze } from "../../Configuration/API_URL";
import { toast } from "react-toastify";

function VerificationQNA(prop) {
  const {
    setPageStatus,
    skipData,
    setQaeRes,
    data,
    setModalState,
    modalData,
    setFreezStatus,
  } = prop;
  const answerSchema = Yup.object().shape({
    ...skipData.reduce((schema, question, index) => {
      schema[`answer${index}`] = Yup.string().required(
        "Mandatory to select answer"
      );
      return schema;
    }, {}),
  });

  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
  } = useForm({
    mode: "onChange",
    resolver: yupResolver(answerSchema),
  });

  const onSubmit = async (data) => {
    const ansList = skipData.map((question, index) => ({
      id: question.id,
      isCorrect: data[`answer${index}`] === "correct",
    }));
    let qaePayload = {
      mobile: localStorage.getItem("mobile"),
      pan: localStorage.getItem("pan"),
      ansList,
    };
    let encPayload = AESEncryption(qaePayload);
    try {
      const responseData = await axios.post(
        Freeze_Unfreeze.SkipAuthenticationProceed,
        `"${encPayload}"`,

        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("ssoToken")}`,
            reserv: 1,
          },
        }
      );
      const res = ApiResDecrypt(responseData?.data);
      if (res?.status === 0) {
        setQaeRes(res.data);
        localStorage.setItem("freeze", res.data.freeze);
        setPageStatus("fnuPage");
        setFreezStatus(res.data.freeze);
      } else {
        setModalState({ modal: true, data: modalData.userFailedToAnsQues });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const onProceed = (e) => {
    e.preventDefault();
    if (isValid) {
      handleSubmit(onSubmit)();
    } else {
      toast.error("Mandatory to select all field");
    }
  };

  return (
    <form onSubmit={onProceed}>
      <div className="card-box validateUserWrapper freezeStatus">
        <div className="card-title">
          <h2 className="h2-css-all">
            Verification Q&A
            <span className="spanblue-clr">
              (Any 3 questions must be answered correctly to proceed)
            </span>
          </h2>

          {/* <div className="status-right-section">
            <h6>Current Account Status:</h6>
            <div className="status-block">Unfrozen</div>
          </div> */}
        </div>
        <div className="card-content">
          <div className="row">
            <div className="freeze-table-wrapper">
              <table className="freeze-table">
                <thead>
                  <tr>
                    <th>Questions</th>
                    <th>Answers</th>
                    <th>Validate Answer</th>
                  </tr>
                </thead>
                <tbody>
                  {skipData.map((question, index) => (
                    <tr key={question.id}>
                      <td>{`Q${index + 1} : ${question.que}`}</td>
                      <td>{question.ans}</td>
                      <td>
                        <input
                          type="radio"
                          id={`correct-${index}`}
                          value="correct"
                          {...register(`answer${index}`)}
                        />
                        <label htmlFor={`correct-${index}`} className="ml-3">
                          Correct
                        </label>

                        <input
                          type="radio"
                          id={`wrong-${index}`}
                          className="ml-5"
                          value="wrong"
                          {...register(`answer${index}`)}
                        />
                        <label htmlFor={`wrong-${index}`} className="ml-3">
                          Wrong
                        </label>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <div className="validate-skip-btn">
            <div className="">
              <button
                type="submit"
                className="validate-btn mr-0 verification-padding"
              >
                Proceed
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
}

export default VerificationQNA;
